<template>
    <div class="header-item" v-bind:class="{'active': isActive}" @click="$emit('click')">
        {{name}}
    </div>
</template>
<script>
export default {
  name: 'HeaderItem',
  props: ['name', 'isActive']
}
</script>

<style scoped>
  .header-item {
    padding: 4px 14px;
    border-radius: 8px;
    background: #FFF;
    box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
    border: 1px solid transparent;
    color: #344054;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
  }

  .header-item:hover {
    box-shadow: 0 2px 4px 0 rgba(16, 24, 40, 0.1);
    transition: .2s;
  }

  .header-item.active {
    border: 1px solid var(--beel-primary);
    background: var(--beel-primary);
    box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
    color: #FFF;
    transition: .2s;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/HeaderItem.vue